import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';
import EmptyData from 'components/EmptyData';
import BookItem from 'modules/Books/components/BookItem';
import BookArrayItem from 'modules/Books/components/BookItem/BookArrayItem';

import EmptyDataBookSvg from '@common/assets/icons/empty-data-books.svg';
import EmptyDataMaterialsSvg from '@common/assets/icons/empty-data-materials.svg';
import { BooksGroupedByProgramsReturnType } from '@common/models/Books/Books';

import { BooksSectionWrap } from './styled';

interface PropsType {
	groupedBooks: BooksGroupedByProgramsReturnType;
	tab?: number;
}

function BooksSection({ groupedBooks, tab = 0 }: PropsType) {
	const { t } = useTranslation();
	if (!groupedBooks || groupedBooks?.length <= 0) {
		return tab === 0 ? (
			<EmptyData
				title={t('resources.emptyBooksTitle')}
				subTitle={t('resources.emptyBooksDescription')}
				icon={<EmptyDataBookSvg />}
			/>
		) : (
			<EmptyData
				title={t('resources.emptyMaterialTitle')}
				subTitle={t('resources.emptyMaterialDescription')}
				icon={<EmptyDataMaterialsSvg />}
			/>
		);
	}

	return (
		<Box sx={{ containerType: 'inline-size' }}>
			<BooksSectionWrap>
				{groupedBooks.map((groupedBook, index) => {
					if ('books' in groupedBook) {
						// object of type {sharedProgram: IProgramModel, books: IBookWithProgress[]}
						return (
							<BookArrayItem
								books={groupedBook.books}
								programName={groupedBook.sharedProgram.name}
								key={index}
							/>
						);
					}
					// single book
					return <BookItem book={groupedBook} key={index} />;
				})}
			</BooksSectionWrap>
		</Box>
	);
}

export default BooksSection;
